/*
 * Module for handling the status of a response template
 */

define([
  "marionette",
  "messaging/messenger",
  "./responseTemplateStatusView",
  "modules/header/kbMenu/kbMenuModel",
], function (Marionette, Messenger, ResponseTemplateStatusView, KbMenuModel) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "responseTemplateStatus";
      this.region = options.region;
    },
    show: function (responseTemplate) {
      if (this.responseTemplate) {
        this.responseTemplate.off("change:response", this._onResponseChange, this);
      }
      this.responseTemplate = responseTemplate;
      this.view = new ResponseTemplateStatusView.responseTemplateStatusView({
        model: responseTemplate,
      });
      responseTemplate.on("change:response", this._onResponseChange, this);
      this.showRegion(this.view);
    },
    _onResponseChange: function () {
      // When response versioning is enabled and the current status is 'Published',
      // then change to 'Pending Response'
      const kb = Messenger.reqres.request("active:kb:model");
      kb.onSynced(function () {
        const versioned = kb.get("responseVersioning");
        const statusId = this.responseTemplate.get("statusId");
        if (versioned && statusId === KbMenuModel.statuses.VERSIONED_PUBLISHED) {
          this.responseTemplate.set("statusId", KbMenuModel.statuses.VERSIONED_PENDING_RESPONSE);
        } else {
          // Need to manually call this, because the response might have changed from empty to
          // non-empty
          this.responseTemplate._updateStatusValue();
        }
      }, this);
    },
  });
});
